import React from "react";
import { usePortalToggles, useUpdatePortalToggles, PortalTogglesInput } from "../../api/settings";
import { useToast } from "../../components/ToastProvider";
import { formatDate } from "../../utils/money";

const TOGGLES: Array<{ key: keyof PortalTogglesInput; label: string; help: string }> = [
  {
    key: "showFullHistory5y",
    label: "Histórico completo de pagamentos",
    help: "Sem isso, o portal mostra só títulos em aberto/vencidos + os últimos 12 meses.",
  },
];

export default function SettingsPage() {
  const { data: settings, isLoading } = usePortalToggles();
  const update = useUpdatePortalToggles();
  const toast = useToast();

  async function handleToggle(key: keyof PortalTogglesInput, value: boolean) {
    try {
      await update.mutateAsync({ [key]: value });
      toast("Configuração do portal atualizada.");
    } catch {
      toast("Não foi possível salvar a configuração.");
    }
  }

  return (
    <div className="d-flex flex-column gap-3" style={{ maxWidth: 680, margin: "0 auto" }}>
      <div className="nt-card p-3">
        <h6
          className="mb-3 pb-2"
          style={{ borderBottom: "1px solid var(--color-divider)", fontWeight: 700 }}
        >
          Portal do cliente
        </h6>

        {isLoading && <div className="text-secondary">Carregando…</div>}

        {settings && (
          <div className="d-flex flex-column gap-3">
            {TOGGLES.map((t) => (
              <div key={t.key} className="d-flex align-items-start gap-3">
                <div className="form-check form-switch mt-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    checked={Boolean(settings[t.key])}
                    disabled={update.isPending}
                    onChange={(e) => handleToggle(t.key, e.target.checked)}
                  />
                </div>
                <div className="flex-grow-1">
                  <div style={{ fontSize: "0.9rem" }}>{t.label}</div>
                  <div className="text-secondary" style={{ fontSize: "0.8rem" }}>
                    {t.help}
                  </div>
                </div>
              </div>
            ))}
            <div className="text-secondary" style={{ fontSize: "0.75rem", borderTop: "1px solid var(--color-divider)", paddingTop: 12 }}>
              Última alteração {formatDate(settings.updatedAt)}
              {settings.updatedByUser && ` por ${settings.updatedByUser.name}`}.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
